module.exports = __webpack_public_path__ + "img/dialogue-icon.945d7947.svg";